import { render } from "./AiDebuggerBubble.vue?vue&type=template&id=4967ad73&scoped=true"
import script from "./AiDebuggerBubble.vue?vue&type=script&lang=js"
export * from "./AiDebuggerBubble.vue?vue&type=script&lang=js"

import "./AiDebuggerBubble.vue?vue&type=style&index=0&id=4967ad73&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4967ad73"]])

export default __exports__